import type { ReactNode } from 'react';
import React, { useEffect } from 'react';
import { useStore } from '@tmsw/powerups.store';

export type LocaleCSSProviderProps = {
  children?: ReactNode;
};
export const LocaleCSSProvider = ({ children }: LocaleCSSProviderProps) => {
  const locale = useStore((state) => state.locale) || `en`;
  useEffect(() => {
    const langCode = locale.split(`-`)[0];
    // console.log(locale);
    // console.log(langCode);
    const localeCSSPath: { [key: string]: string } = {
      en: `static/media/en/css/index.css`, //English Sans
      ar: 'static/media/ar/css/index.css', //Arabic Arabic
      az: 'static/media/az/css/index.css', //Azerbeijan Sans
      bg: 'static/media/bg/css/index.css', //Bulgaria Sans
      ca: 'static/media/ca/css/index.css', //Catalan Sans
      cs: 'static/media/cs/css/index.css', //Czech Sans
      de: 'static/media/de/css/index.css', //Germany Sans
      el: 'static/media/el/css/index.css', //Greek Sans
      es: 'static/media/es/css/index.css', //Spain Sans
      et: 'static/media/et/css/index.css', //Estonian Sans
      fi: 'static/media/fi/css/index.css', //Finland Sans
      fr: 'static/media/fr/css/index.css', //French Sans
      he: 'static/media/he/css/index.css', //Hebrew Hebrew
      hr: 'static/media/hr/css/index.css', //Croatia Sans
      id: 'static/media/id/css/index.css', //Indonesia ???
      it: 'static/media/it/css/index.css', //Italian Sans,
      ka: 'static/media/ka/css/index.css', //Georgia GEORGIAN
      ko: 'static/media/ko/css/index.css', //South Korea  KOREAN
      lt: 'static/media/lt/css/index.css', //Lithuania Sans
      lv: 'static/media/lv/css/index.css', //Latvia Sans
      ms: 'static/media/ms/css/index.css', //Malaysia Malayalam ???
      nl: 'static/media/nl/css/index.css', //Dutch // Netherlands - Belgium Sans
      nz: `static/media/nz/css/index.css`, //New Zealand Sans
      pl: 'static/media/pl/css/index.css', //Polish Sans
      pt: 'static/media/pt/css/index.css', //Portuguese - Brazilian Portuguese Sans
      ro: 'static/media/ro/css/index.css', //Romania / Moldova Sans
      ru: 'static/media/ru/css/index.css', //Russian Sans ? Cyrylic
      sk: 'static/media/sk/css/index.css', //Slovakia Sans
      sl: 'static/media/sl/css/index.css', //Slovenia Sans
      sr: 'static/media/sr/css/index.css', //Serbia Sans ? Cyrylic
      th: 'static/media/th/css/index.css', //Thailand THAI
      tr: 'static/media/tr/css/index.css', //Turkey Sans?
      vi: 'static/media/vi/css/index.css', //Vietnam Sans?
      zh: 'static/media/zh/css/index.css', //Hong Kong HONG KONG
      zu: 'static/media/zu/css/index.css', //Zulu Sans?
    };
    // TODO: Check if any region specific charsets
    const localeCSSFile = localeCSSPath[langCode];
    // console.log(localeCSSFile);

    if (localeCSSFile) {
      let link = document.querySelector(
        // 'link[href*="static/css/index.css"]'
        `link[href*="${localeCSSFile}"]`
      ) as HTMLLinkElement;
      // console.log(link);
      if (!link) {
        link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = localeCSSFile;

        document.head.appendChild(link);
        link.href = `${localeCSSFile}`;
        console.log(`Appending locale specifc css: ${link}`);
      }
    }
  }, [locale]);

  return children;
};
